<!--
 Copyright 2023, Avation Medical. All rights reserved.
 
 This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
 or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.
-->

<div class="login-page">
  <div class="login-header">
      <img src="/assets/icons/vivally-logo.svg"/>
  </div>
  <div class="login-body" style="text-align: start;">
    <div class="html-container">
      <div *ngIf="htmlLoc$ | async as htmlLoc" class="html-window" [innerHtml]="htmlLoc"></div>>
    </div>
    <form>
      <mat-checkbox
      class="example-margin"
      [(ngModel)]="checked"
      name="checked"
      >
      I accept the <a href="https://avation.com/terms-of-use">terms and conditions</a>
    </mat-checkbox>
  </form>
    <div style="padding-top: 15px; padding-bottom: 15px; gap: 30px; flex-grow: 0; flex-basis: auto; display: flex; justify-content: center;">
      <button id="decline" class="push-button tertiary" (click)="onDecline()">Decline</button>
      <button id="accept" class="push-button primary" (click)="onAccept()" [disabled]="!canAccept && !checked">Accept</button>
    </div>
  </div>
  <vivally-footer></vivally-footer>
</div>